<template>
  <div id="user">

    <v-snackbar v-model="snackbar" top :timeout="0">
      {{ responseError }}
      <v-btn class="snackbar_btn" text @click="snackbar = false">
        <span>Chiudi</span>
      </v-btn>
    </v-snackbar>

    <base-material-card v-if="user" color="primary" :title="user.name" inline icon="mdi mdi-cogs">
      <v-btn color="success" absolute fab bottom right @click="updatePassword">
        <v-icon>fa-check</v-icon>
      </v-btn>


      <v-form ref="updatePasswordForm" v-model="validPasswordForm">
        <v-card-title>Modifica la tua password</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="old_password"
                :rules="[inputRules.req]"
                type="password"
                label="Password attuale"
                required
              >

              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="new_password"
                :rules="[passwordRules.min,inputRules.req]"
                type="password"
                label="Nuova password"
                required
              >

              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="passwordConfirmation"
                :rules="[passwordRules.min,passwordMatches]"
                type="password"
                label="Conferma nuova password"
                required
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </base-material-card>
    <v-divider class="mt-11 mb-7"></v-divider>


    <base-material-card v-if="user" color="primary" title="Ads.txt" inline icon="mdi mdi-text-box-check">
      <v-card-text>
        <h3 class="text-highlight">Il file ADS.txt è fondamentale per l'erogazione della pubblicità e va aggiornato
          periodicamente per consentirci di monetizzare al meglio sul tuo sito e non perdere nemmeno un centesimo di
          potenziali revenue. <br/> Scarica o copia il file ADS.txt aggiornato.</h3>
        <br/>

        <v-btn class="mr-3 my-2" href="https://cdn.yobee.it/ads.txt" link target="_blank">
          <span class="px-5">SCARICA ADS.TXT</span>
        </v-btn>

        <v-btn class="mr-3 my-2" @click="copyADSTXT">
          <span>COPIA STRINGHE ADS.TXT</span>
        </v-btn>

        <v-divider class="my-10"></v-divider>
        <h3 class="text-highlight">Il tuo sito è realizzato con <strong>Wordpress?</strong> Scarica il nostro plugin di
          soli 2 KB, caricalo tramite piattaforma WP in "Plugin > Aggiungi nuovo" o via FTP, attivalo e non dovrai più
          aggiornare l'ADS.txt manualmente!</h3>
        <br/>
        <v-btn class="mr-3 my-2" href="https://cdn.yobee.it/yb-adstxt.zip" link target="_blank">
          <span class="px-5">SCARICA PLUGIN ADS.TXT</span>
        </v-btn>

      </v-card-text>
    </base-material-card>


    <v-divider class="my-10"></v-divider>

    <base-material-card v-if="user" color="primary" title="CMP" inline icon="mdi mdi-lock-open-check">
      <v-card-text>
        <h3 class="text-highlight">È necessario implementare il CMP per consentire agli utenti che navigano sul tuo sito
          di accettare o meno il trattamento dei dati personali. In assenza di consenso l'erogazione pubblicitaria viene
          automaticamente bloccata. <br/></h3>
        <!--<br />
        <v-btn @click="copyCMP"><span class="px-5">COPIA SCRIPT CMP</span></v-btn>-->
      </v-card-text>
    </base-material-card>

    <v-divider class="my-10"></v-divider>

    <base-material-card v-if="user" color="primary" title="I tuoi dati" inline icon="mdi mdi-account">
      <v-btn color="success" absolute fab bottom right @click="updateUser">
        <v-icon>fa-check</v-icon>
      </v-btn>
      <v-form ref="updateUserForm" v-model="validUserForm">
        <v-card-text>

          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="user.phone"
                type="number"
                label="Recapito telefonico"
              >

              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="user.registered_office"
                type="text"
                label="Nome sede legale"
              >

              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="user.registered_office_address"
                type="text"
                label="Indirizzo sede legale"
              >

              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="user.fiscal_code"
                type="text"
                label="Codice fiscale"
              >

              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="user.vat_number"
                type="text"
                label="Numero Partita IVA"
              >

              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="user.name"
                type="text"
                label="Nome rappresentante legale"
              >

              </v-text-field>
            </v-col>
          </v-row>

        </v-card-text>
      </v-form>

    </base-material-card>


  </div>
</template>

<script>
export default {

  name: 'User',
  data() {
    return {
      user: '123',
      password: '',
      old_password: '',
      new_password: '',
      passwordConfirmation: '',
      responseError: '',
      validPasswordForm: false,
      validUserForm: false,
      passwordRules: {
        min: v => v.length >= 8 || 'Min 8 characters',
      },
      inputRules: {
        req: v => !!v || 'Il campo è obbligatorio',
        // fiscalcode: v => (v.length == 11 || v.length == 0)|| 'Il campo deve contenere 11 caratteri'

      },

      snackbar: false,
      cmp: '',
      adstxt: ''

    }

  },

  computed: {
    passwordMatches() {
      return () => (this.new_password === this.passwordConfirmation) || 'Le password non corrispondono'
    },
  },
  methods: {
    updatePassword() {
      // console.log(this.user);

      if (this.$refs.updatePasswordForm.validate()) {
        this.$store.dispatch('updatePassword', {
          password: this.old_password,
          new_password: this.new_password,
          new_password_confirmation: this.passwordConfirmation
        }).then(response => {
          // console.log(response)
        }).catch(error => {
          console.log('Errore! ', error)
          if (error.response.status === 405) {
            this.responseError = 'Errore nel salvataggio dei dati. Contatta l\'amministratore'
          } else {
            this.responseError = error.response.message
          }
          this.snackbar = true
        })
      }
    },

    updateUser() {
      // console.log(this.user);

      if (this.$refs.updateUserForm.validate()) {
        this.$store.dispatch('updateUser', this.user).then(response => {
          // console.log(response)
        }).catch(error => {
          console.log('Errore! ', error)
          if (error.response.status === 405) {
            this.responseError = 'Errore nel salvataggio dei dati. Contatta l\'amministratore'
          } else {
            this.responseError = error.response.message
          }
          this.snackbar = true
        })
      }

    },
    copyCMP() {
      const textarea = document.createElement('textarea')
      textarea.value = this.cmp
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.responseError = 'Il codice del CMP è stato copiato, puoi ora incollarlo a inizio Head prima di qualunque altro script già presente e avvisarci una volta implementato per procedere con l\'attivazione.'
      this.snackbar = true

    },
    copyADSTXT() {
      const textarea = document.createElement('textarea')
      textarea.value = this.adstxt
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.responseError = 'Le stringhe di Yobee sono state copiate, puoi ora incollarle all\'interno del tuo file ADS.txt';
      this.snackbar = true

    },
  },
  mounted() {
    axios.get('cmptxt').then(response => {
      this.cmp = response.data
    }).catch(error => {
      console.log(error)
    })

    axios.get('ads-txt').then(response => {
      this.adstxt = response.data
    }).catch(error => {
      console.log(error)
    })

    // console.log("auth",Object.keys( this.$store.getters.auth).length);
    this.$store.dispatch('me').then(response => {
      this.user = response.data
    }).catch(error => {
      console.log('ERRORE!', error)
    })
  }
}
</script>

<style scoped>

.snackbar_btn span {
  color: #3682d8;
}
</style>
